import { MondayGateway } from './monday-gateway.interface';

export const initMondayAPI = (apiSlice: any, gateway: MondayGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['MondayBoard'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getAllMondayBoard: builder.query({
          query: gateway.getAllMondayBoard,
          providesTags: ['MondayBoard'],
        }),
        deleteMondayBoard: builder.mutation({
          query: gateway.deleteMondayBoard,
          invalidatesTags: ['MondayBoard'],
        }),
        postMondayBoard: builder.mutation({
          query: gateway.postMondayBoard,
          invalidatesTags: ['MondayBoard'],
        }),
        updateMondayBoard: builder.mutation({
          query: gateway.updateMondayBoard,
          invalidatesTags: ['MondayBoard'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface MondaySliceType {
  useGetAllMondayBoardQuery: Function;
  useDeleteMondayBoardMutation: Function;
  usePostMondayBoardMutation: Function;
  useUpdateMondayBoardMutation: Function;
}
